export type PermissionAction = "read" | "write"  | "delete";

export interface Permission {
    action: PermissionAction;
    description?: string | null;
    id?: number | null;
    name: string;
    resource: string;
}

export const permissionActions: PermissionAction[] = ["read", "write", "delete"];

export const permissionResources = [
    "users", "operator", "customers", "cards", "addresses", "employees", "hunters",
    "promocodes", "wallets", "sales", "sale_items", "user_zones", "reports",
    "notifications", "whatsapp"
];

export const hasPermission = (userPermissions: string[] | undefined | null, resource: string, action: PermissionAction) => (
    !!userPermissions?.includes(`${resource}.${action}`)
);

// Nombres de sección tal como aparecen en la barra de navegación (src/components/layouts/Lists.tsx),
// para que la tabla de permisos del modal de Roles sea legible en vez de mostrar el resource crudo.
export const resourceLabels: Record<string, string> = {
    users: "Operadores",
    roles: "Roles",
    hunters: "Hunters",
    wallets: "Wallets",
    promocodes: "Eventos",
    sales: "Servicios",
    whatsapp: "Bitacora Bot",
    sale_items: "Productos",
    employees: "Goodlookeros",
    countries: "Países",
    zones: "Zonas",
    categories: "Categorías",
    banners: "Banners"
};

export const getResourceLabel = (resource: string) => resourceLabels[resource] || resource.replace(/_/g, " ");
